import { cn } from '@/utils/tailwind';

export const LayoutTableContainer = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'flex h-full w-full max-w-full flex-1 flex-shrink-0 flex-col gap-[16px] overflow-hidden bg-white px-[60px] py-[20px]',
        className,
      )}
    >
      {children}
    </div>
  );
};
